<template>
  <div v-if="data && !fechada" class="data-saudacao" :style="{ background: data.gradiente }">
    <v-tooltip bottom>
      <template #activator="{ on, attrs }">
        <v-btn
          icon
          x-large
          class="data-saudacao__icone mr-3"
          aria-label="Celebrar de novo"
          v-bind="attrs"
          v-on="on"
          @click="celebrarAgora"
        >
          <v-icon size="44">{{ data.icone }}</v-icon>
        </v-btn>
      </template>
      <span>Celebrar de novo</span>
    </v-tooltip>
    <div class="flex-grow-1">
      <div class="data-saudacao__titulo">{{ data.titulo }}</div>
      <div class="data-saudacao__texto">{{ data.texto }}</div>
      <div class="data-saudacao__dica">
        Não quer o tema? Desligue em
        <router-link :to="{ name: 'configuracoes.datasComemorativas' }" class="data-saudacao__link">
          Configurações › Datas comemorativas
        </router-link>
      </div>
    </div>
    <v-btn icon small dark class="ml-2" aria-label="Fechar" @click="fechar">
      <v-icon small>mdi-close</v-icon>
    </v-btn>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { dataComemorativaAtiva } from "@/plugins/datasComemorativas";
import { celebrar } from "@/plugins/confete";

// Fechar a saudação e a celebração automática valem até o fim da sessão do navegador
// e só para a data atual (guardam a chave da data).
const CHAVE_FECHADA = "pontofiq.data-comemorativa.saudacao-fechada";
const CHAVE_CELEBRADA = "pontofiq.data-comemorativa.celebrada";

function lerSessao(chave) {
  try {
    return sessionStorage.getItem(chave);
  } catch (e) {
    return null;
  }
}

function gravarSessao(chave, valor) {
  try {
    sessionStorage.setItem(chave, valor);
  } catch (e) {
    // sessionStorage indisponível: vale só até recarregar a página.
  }
}

export default {
  name: "EDataComemorativaSaudacao",
  data() {
    return { fechadaEm: lerSessao(CHAVE_FECHADA) };
  },
  computed: {
    ...mapGetters("Auth", ["user"]),
    ...mapGetters("AppConfigurations", ["moduloAtivo"]),
    data() {
      return dataComemorativaAtiva(this.user, this.moduloAtivo);
    },
    fechada() {
      return Boolean(this.data) && this.fechadaEm === this.data.chave;
    },
  },
  watch: {
    // O usuário pode chegar depois do primeiro render: celebra assim que a data fica ativa.
    data: {
      immediate: true,
      handler(data) {
        if (!data || this.fechada || lerSessao(CHAVE_CELEBRADA) === data.chave) return;
        gravarSessao(CHAVE_CELEBRADA, data.chave);
        celebrar(data);
      },
    },
  },
  methods: {
    celebrarAgora() {
      celebrar(this.data);
    },
    fechar() {
      this.fechadaEm = this.data.chave;
      gravarSessao(CHAVE_FECHADA, this.data.chave);
    },
  },
};
</script>

<style scoped>
.data-saudacao {
  display: flex;
  align-items: center;
  padding: 16px 20px;
  margin-bottom: 16px;
  border-radius: 16px;
  color: #ffffff;
  box-shadow: 0 6px 18px rgba(30, 10, 60, 0.3);
}

.data-saudacao__icone {
  color: #ffffff !important;
}

.data-saudacao__titulo {
  font-size: 18px;
  font-weight: 800;
}

.data-saudacao__texto {
  font-size: 14px;
  opacity: 0.92;
}

.data-saudacao__dica {
  font-size: 12px;
  opacity: 0.85;
  margin-top: 4px;
}

.data-saudacao__link {
  color: #ffffff !important;
  font-weight: 700;
  text-decoration: underline;
}
</style>
